module.exports = "/fonts/Flaticon.woff?5be3e43c13c3eb021d15e6682d098d4c";